<template>
  <div>
    <div>
      <b class="red--text headline mr-1">{{ parcelsFee | toTwb }}</b>元
      <span
        v-if="srItem.addrid==='1050'"
        class="grey--text ml-2"
      >(海關監管倉)</span>
    </div>
    <div class="grey--text caption">
      <div
        v-if="srItem.firstWeight > 0 && srItem.addlWeight > 0"
      >
        <div v-if="settlementWeight > 1000">
          （{{ srItem.fwFee }}元首重*1KG+{{ srItem.awFee }}元續重*{{ (settlementWeight-1000)/1000 }}KG）
        </div>
        <div v-else>
          （{{ srItem.fwFee }}元首重*1KG）
        </div>
      </div>
      <!-- 首重 -->
      <div
        v-else-if="srItem.firstWeight > 0"
      >
        <!-- （{{ settlementWeight | toKg }}KG*{{ srItem.fwFee }}元={{ computerParcelFee(settlementWeight,srItem.fwFee) | toTwb }}元） -->
        （{{ srItem.fwFee }}元/KG*{{ settlementWeight / 1000 }}KG={{ computeFeeBySrItemAndWeight({srItem:srItem,weight: settlementWeight}) | toTwb }}元）
      </div>
    </div>
  </div>
</template>
<script>
import calc from 'calculatorjs'
import { computeFeeBySrItemAndWeight, computerSettlementWeight } from '@g/utils/orderUtils'

export default {
  props: {
    srItem: Object,
    chgWeight: Number,
  },
  data () {
    return {
      computeFeeBySrItemAndWeight,
    }
  },
  computed: {
    settlementWeight () {
      return computerSettlementWeight(this.chgWeight, this.srItem.minWeight, true, this.srItem.transport)
    },
    parcelsFee () {
      const srItem = this.srItem
      const settlementWeight = this.settlementWeight
      if (srItem.firstWeight > 0 && srItem.addlWeight > 0) {
        if (settlementWeight > 1000) {
          return Math.floor(calc(`${srItem.fwFee} + ${settlementWeight / 1000 - 1} * ${srItem.awFee}`))
        } else {
          return calc(`${settlementWeight / 1000} * ${srItem.fwFee}`)
        }
      } else {
        return calc(`${settlementWeight / 1000} * ${srItem.fwFee}`)
      }
    },
  }
}
</script>
